import React from "react";
import styled from "@emotion/styled";

const RadioInput = styled.input`
  cursor: pointer;
  width: 18px;
  height: 18px;
  align-self: flex-start;
  appearance: initial;
  border: solid 1px rgba(119, 121, 132, 0.2);
  border-radius: 50%;

  &:checked {
    border: solid 6px #12b2ea;
    width: 18px;
    height: 18px;
    box-sizing: border-box;
    outline: none;
  }
  &:focus {
    border: solid 6px #12b2ea;
    width: 18px;
    height: 18px;
    box-sizing: border-box;
    outline: none;
  }
`;

const StyledRadioButton = ({
  checked,
  name,
  value,
  onChange,
  readOnly,
  styles = {}
}) => (
  <RadioInput
    style={styles}
    type="radio"
    name={name}
    value={value}
    checked={checked}
    onChange={onChange}
    readOnly={readOnly}
  />
);

export default StyledRadioButton;
